export const iconFontAwesomeMapsHeart = (
	<i className="fa-solid fa-heart"></i>
);
